import React from "react";

import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import "./requirementList.scss";

const RequirementList = ({ password, requirements, touched }) => {
  const requirementList = requirements.map((requirement) => {
    let validationState = password && new RegExp(requirement.regex).test(password) ? "true" : "empty";

    if (touched && validationState === "empty") {
      validationState = "error";
    }

    return {
      ...requirement,
      validationState,
    };
  });

  return (
    <div className="requirement-list">
      <div className="requirement-list__headline"><FormattedMessage id="ssp.password.requirements" /></div>
      <Row className="requirement-list__content">
        {requirementList.map((requirement) => (
          <Col key={requirement.id} xs={6} md={4} lg={6}>
            <div className={`requirement requirement--${requirement.validationState}`}>
              {requirement.text}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

RequirementList.propTypes = {
  password: PropTypes.string.isRequired,
  requirements: PropTypes.arrayOf(PropTypes.shape({
    regex: PropTypes.oneOfType([PropTypes.object]).isRequired,
    text: PropTypes.string.isRequired,
  })).isRequired,
  touched: PropTypes.bool.isRequired,
};

export default RequirementList;
